import './public-path';
import ReactDOM from 'react-dom';
import App from './app';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { AliveScope } from 'react-activation';
import { ConfigProvider } from 'antd';
import { getScript } from './utils/get-script';
import { Provider } from 'react-redux';
import zhCN from 'antd/es/locale/zh_CN';
import store from '@/store/store';

import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');
import { createContext } from 'react';
import './global.less';
import { onWindowOpen } from './common/document-event/on';

window.getScript = getScript;

const basename = window.__POWERED_BY_QIANKUN__ ? '/lhb-micro-pms' : '/';
export {
  basename
};

export const MainAppContext = createContext<{ container?: any }>({});
const { Provider: MainAppProvider } = MainAppContext;
if (!window.__POWERED_BY_QIANKUN__) {
  ConfigProvider.config({
    prefixCls: 'resant', // 为了避免和主应用的 .ant- 冲突，把微应用的 .ant- 变成 .resant-
  });
}

// 用户信息上下文
export const UserInfoProvider = createContext<{info?:any, modules?:any, companies?: any}>({ info: {}, modules: [], companies: [] });



// 改造生命后期
function render(props) {

  const { container, isHash, chaType, customToken, customUserId, customTenantId } = props;
  window.chaType = chaType; // 插入项目来源
  window.customToken = customToken; // 插入特意化token
  window.customUserId = customUserId; // 插入特意化用户id
  window.customTenantId = customTenantId; // 插入特意化租户id


  const NewRouter = isHash ? HashRouter : BrowserRouter;
  onWindowOpen((path) => {
    if (path.indexOf('http') === 0) {
      window.open(path);
    } else {
      if (window.__POWERED_BY_QIANKUN__) {
        window.open(`${isHash ? '/#/lhb-micro-pms' : '/lhb-micro-pms'}${path}`);
      } else {
        window.open(`${isHash ? '/#' : ''}${path}`);
      }
    }
  });
  if (window.__POWERED_BY_QIANKUN__) { // 微应用的时候需要自行把svg copy到微应用中，qiankun未做此类功能
    setTimeout(() => {
      if (container) {
        const resIconfontSvg = document.querySelector('symbol[id^=res-servise-]')?.parentNode?.cloneNode(true);
        const commonPCIconfontSvg = document.querySelector('symbol[id^=pc-common-icon-]')?.parentNode?.cloneNode(true);
        const pmsPCIconfontSvg = document.querySelector('symbol[id^=icon]')?.parentNode?.cloneNode(true);
        resIconfontSvg && container.appendChild(resIconfontSvg);
        commonPCIconfontSvg && container.appendChild(commonPCIconfontSvg);
        pmsPCIconfontSvg && container.appendChild(pmsPCIconfontSvg);
      }
    }, 0);
  }
  if (process.env.NODE_ENV !== 'development') {
    // @ts-ignore
    // const host = window.location.host;
    // const reg = /location/gi;
    const customToken = window.customToken || 'newPmsToken';
    const customUserId = window.customUserId || 'newPmsUserId';
    const customTenantId = window.customTenantId || 'newPmsCompanyId';
    const chaType = window.chaType || 'PMS';

    window.LHBbigdata.init({
      isSpa: true,
      cha_type: chaType,
      extendOuterConfig: [{
        key: 'token',
        target: customToken,
      }, {
        key: 'user_id',
        target: customUserId,
      }, {
        key: 'tenant_id',
        target: customTenantId,
      }],
      extendMsgConfig: [{
        key: 'source',
        target: 'source',
      }, {
        key: 'company_id',
        target: customTenantId,
      }, {
        key: 'store_id',
        target: 'placeIds',
      }],
      si: 'pc',
      sendFunc: function(params: any, config: any) {
        try {
          window.LHBbigdata.xhrTool.send(`${config[process.env.NODE_TYPE === 'pe' ? 'logPathPro' : 'logPathPre']}`, params);
        } catch (err) {}
      },
    });
    // 线上环境不再提示接口请求被取消
    window.addEventListener('unhandledrejection', function(event) {
      if (event.reason && event.reason.message && event.reason.message?.indexOf('您取消了请求') > -1) {
        event.preventDefault();
      }
    });
  } else {
    // 本地开发环境过滤 ResizeObserver loop limit exceeded 报错
    window.addEventListener('error', (err) => {
      try {
        if (err.type === 'error') {
          const iframe: any = (container || document)?.querySelector('#webpack-dev-server-client-overlay', err.message);
          console.log(`iframe = `, iframe?.contentWindow?.document);
          if (err.message.indexOf('ResizeObserver loop limit exceeded') > -1 || err.message.indexOf('ResizeObserver loop completed with undelivered notifications') > -1) {
            iframe?.contentWindow.document?.querySelector('#webpack-dev-server-client-overlay-div button')?.click();
          }
        }
      } catch (_) {}
    });
    // 本地开发环境过滤 无意义 报错
    window.addEventListener('unhandledrejection', function(event) {
      const iframe: any = (container || document)?.querySelector('#webpack-dev-server-client-overlay', event.reason);
      if (event.reason && event.reason.message && event.reason?.message?.indexOf('您取消了请求') > -1) {
        iframe?.contentWindow.document?.querySelector('#webpack-dev-server-client-overlay-div button')?.click();
      }
    });
  }
  ReactDOM.render(
    <MainAppProvider value={{ container }}>
      {
        <NewRouter basename={basename} >
          <ConfigProvider
            locale={zhCN}
            prefixCls='resant'
            getPopupContainer={() => {
              return container ? container.querySelector('#popContainer') : document.querySelector('#popContainer');
            }}
          >
            <Provider store={store}>
              <AliveScope> <App /></AliveScope>
            </Provider>
            {/* {
              window.__POWERED_BY_QIANKUN__ ? (
              <Provider store={store}>
                <AliveScope> <App /></AliveScope>
              </Provider>
              ) : <AliveScope> <App /></AliveScope>
            } */}
          </ConfigProvider>
        </NewRouter>
      }
    </MainAppProvider>
    ,
    container ? container.querySelector('#lhb-micro-pms') : document.querySelector('#lhb-micro-pms'));
}

if (!window.__POWERED_BY_QIANKUN__) {
  render({});
}

export async function bootstrap() {
  console.log('微服务第一次初始化');
}

export async function mount(props) {
  console.log(props, '6666111');
  console.log('微服务正在挂载中');
  props.onGlobalStateChange((state, prev) => {
    // state: 变更后的状态; prev 变更前的状态
    console.log(state, prev);
  });
  render(props);
}

export async function unmount(props) {
  const { container } = props;
  console.log('微服务正在卸载中');
  ReactDOM.unmountComponentAtNode(container ? container.querySelector('#lhb-micro-pms') : document.querySelector('#lhb-micro-pms'));
}
